import * as React from 'react';
import CardsManager, { CardsManagerCallbacks } from '../CardsManager/CardsManager';
import FindBook from '../Header/FindBook/FindBook';
import './WelcomeBook.css';
import { Book as BookType } from '../../types/Book';
import getSuggestedBooks from '../../requests/getSuggestedBooks';
import Book from '../Book/Book';
import BookDialogPreview from '../BookDialogPreview/BookDialogPreview';
import Button from '../Button/Button';

interface Props {
	callbacks: CardsManagerCallbacks;
}

const WelcomeBook: React.FC<Props> = props => {
	const [suggestedBooks, setSuggestedBooks] = React.useState<BookType[]>([]);
	const [selectedBook, setSelectedBook] = React.useState('');

	/*React.useEffect(() => {
		getSuggestedBooks().then(result => {
			setSuggestedBooks(result);
		})
	}, []);*/

	return <>
		<div className="welcome__wrapper">				
				<div className="welcome__subheader">
					Найдите книгу, которую вы прочитали ранее, читаете сейчас или только планируете прочесть
				</div>

				<FindBook callbacks={props.callbacks} withoutInitial={true} />

				<div className="welcome-buttons"></div>

				{suggestedBooks.length > 0 && <div className="welcome-suggested">
					<div className="welcome-suggested__header">
						Что читают
					</div>

					<div className="welcome-suggested__books">
						{suggestedBooks.map(book => (
							<Book type="mini" book={book} onClick={() => setSelectedBook(book.externalId)}/>
						))}
					</div>

					<BookDialogPreview
						bookExternalId={selectedBook}
						onClose={() => setSelectedBook('')}
						onSaved={() => setSelectedBook('')}
						saveCard={props.callbacks.addCard}
						saveProperties={props.callbacks.saveCardProperties}
					/>
				</div>}
		</div>
	</>
};

export default WelcomeBook;
